<template>
  <div style="min-width: 1000px">
    <router-view />
  </div>
</template>

<script>
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'Layout',
  data () {
    return {
      menu: this.$store.state.user.resouces,
      logo: { icon: 'su-icon-logo', title: '智慧校园' },
      host: window.location.protocol + '//' + window.location.host
    }
  },
  components: {
  },
  mixins: [ResizeMixin],
  mounted () {

  },
  computed: {
    sidebar () {
      return this.$store.state.app.sidebar
    },
    device () {
      return this.$store.state.app.device
    },
    classObj () {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    routerHandle (item) {
      if (item.server.includes(this.host)) {
        this.$router.push({ path: item.path })
      } else {
        let path = item.path.replace('/', '')
        var route = item.server + path
        window.location.href = route
      }
    },
    checkSelfRoute () {

    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.app-main {
  /*50 = navbar  */
  min-height: 0;
  position: relative;
  overflow: hidden;
}
.main-container {
  margin-left: 50px !important;
  width: calc(100% - 50px);
}
.appFooter {
  font-size: 12px;
  color: #bec9d2;
  line-height: 20px;
  text-align: center;
}
.iframe {
  height: calc(100vh - 50px);
  width: 100%;
}
</style>
